/* Analytics helpers: the intended GA4 measurement ID (property 555216009) and the admin-route
   exclusion used to switch GA4 off while navigating inside the beheeromgeving.
   Keep GA4_MEASUREMENT_ID and the admin prefix in sync with the inline loader in index.html. */

export const GA4_MEASUREMENT_ID = 'G-LSCXM0WCHK';

const ANALYTICS_EXCLUDED_PREFIX = '/kh-admin';

export function isAnalyticsExcludedPath(pathname: string): boolean {
  return pathname === ANALYTICS_EXCLUDED_PREFIX || pathname.startsWith(`${ANALYTICS_EXCLUDED_PREFIX}/`);
}

// Google's documented opt-out flag; gtag checks it before sending any hit for this ID.
export function setGa4DisabledForPath(pathname: string): void {
  (window as unknown as Record<string, unknown>)[`ga-disable-${GA4_MEASUREMENT_ID}`] =
    isAnalyticsExcludedPath(pathname);
}
